import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LatestEvents from "../feature/Common/LatestEvents";
import CategorySlider from "../components/Slider/CategorySlider";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import { injectModels } from "../redux/injectModels";
import { Button, Dropdown } from "react-bootstrap";
import { routes } from "../constants/routes";
import { ModelPopup } from "../components/Common/ModelPopup";
import {
  AuthService,
  StaticPageContentService,
  SubscriptionService,
} from "../services";
import { globalConstant } from "../constants/globalConstant";
import { handleConsoleError } from "../utils/common-methods";

function HomePage(props) {
  const { urlParam,urlRole } = useParams();
  const navigate = useNavigate();
  //const [id, setId] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);
  const dispatch = useDispatch();
  const [termsShow, setTermsShow] = useState(false);

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterName, setNewsletterName] = useState("");
  // const [emailError, setEmailError] = useState("");
  // const [nameError, setNameError] = useState("");
  // const [termError, setTermError] = useState("");
  const [isTermsAccepted, setTermAccepted] = useState(false);
  let loginUser = AuthService.getLoginUser();

  useEffect(() => { 
    // setId(localStorage.getItem("access_token"));
    const alreadyLogin =loginUser?.id?true:false;
  //  console.log(" alreadyLogin :: ",alreadyLogin);
    if(urlParam?.includes("signup") && !alreadyLogin)
    {
      dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.SIGNUP_MODAL,
    });
    
    }
     if(urlParam?.includes("login") && !alreadyLogin)
    {
     dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.LOGIN_MODAL,
    });
    }
  }, []);

  useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      try {
        props.application.setLoading(true);
        await props.application.getRoles();
        await getStaticPages();

        const res = await props.application.getEventCategories();
        if (res?.isSuccess) {
          props.application.setLoading(false);
          if (res?.data?.length > 0) {
            setActiveCategory(res?.data[0]?.id);
            await getEventsByCategoryId(res?.data[0]?.id);
          }
        } else {
          props.application.setLoading(false);
         // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          return;
        }
      } catch (e) {
        // Restoring token failed
       const message= handleConsoleError(e);
        props.application.setLoading(false);
        toast.error(e?.message || message);
      }
    };

    bootstrapAsync();
  }, []);

  const getEventsByCategoryId = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await props.application.getEventsByCategoryId(id);
      if (res?.isSuccess) {
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
        toast.error(res?.Errors?.[0]?.Message);
        return;
      }
    } catch (e) {
      // Restoring token failed
      const message =handleConsoleError(e);
      props.application.setLoading(false);
      toast.error(e?.message || message);
    }
  };

  const getStaticPages = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await StaticPageContentService.getStaticPageByUrl(
        "terms-condition"
      );
      if (res?.isSuccess) {
        props.application.setLoading(false);
        // if (res?.data.length > 0) {

        globalConstant.termsHtmlText = res?.data?.content;

        // const termsData = (res?.data ?? []).filter(data=> data.url === "terms-condition");
        // const privacyData = (res?.data ?? []).filter(data=> data.url === "privacy-policy");
        // const aboutData = (res?.data ?? []).filter(data=> data.url === "about-us");
        // if (termsData.length > 0) {
        //   globalConstant.termsHtmlText = termsData[0].content;
        // }
        // if (privacyData.length > 0) {
        //   globalConstant.privacyHtmlText = privacyData[0].content;
        // }
        // if (aboutData.length > 0) {
        //   globalConstant.aboutHtmlText = aboutData[0].content;
        // }
        // terms-condition
        //}
      } else {
        props.application.setLoading(false);
       // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        return;
      }
    } catch (e) {
      // Restoring token failed
      const message=handleConsoleError(e);
      props.application.setLoading(false);
      toast.error(e?.message || message);
    }
  };

  const handleSignup = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.SIGNUP_MODAL,
    });
  };

  const handleRoleChange = (role) => {
    dispatch({
      type: CONSTANTS.SET_ACTIVE_ROLE,
      payload: role,
    });
  };

  const handleNameChange = (e) => {
    e.preventDefault();
    const val = e.target.value;
    // if (val === "") {
    //   setNameError("Full name is required");
    // } else {
    //   setNameError("");
    // }

    setNewsletterName(val);
  };

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target.value.trim();
    // if (val === "") {
    //   setEmailError("Email is required");
    // } else if (!emailRegex.test(val)) {
    //   setEmailError("Please enter a valid email");
    // } else {
    //   setEmailError("");
    // }

    setNewsletterEmail(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    props.application.setLoading(true, "");

    let valid = true;
    if (newsletterEmail?.trim() === "") {
      // setEmailError("Email is required");
      toast.error("Email is required");
      valid = false;
    } else {
      if (!globalConstant.emailRegex.test(newsletterEmail)) {
        toast.error("Please enter a valid email");
        valid = false;
      } else {
        //setEmailError("");
      }
    }
    if (newsletterName?.trim() === "") {
      toast.error("Full name is required");
      // setNameError("Full name is required");
      valid = false;
    } else {
      //setNameError("");
    }

    if (!valid) {
      props.application.setLoading(false, "");
      return;
    } else {
      if (!isTermsAccepted) {
        // setTermError("Please accept terms & conditions.");
        toast.error("Please accept terms & conditions.");
        props.application.setLoading(false, "");
        return;
      }
      const data = {
        name: newsletterName?.trim(),
        email: newsletterEmail?.trim(),
      };
      try {
        props.application.setLoading(true);
        const response = await SubscriptionService.subscribeNewsletter(data);
        if (response?.isSuccess) {
          props.application.setLoading(false);

          toast.success(response?.message);
          setNewsletterEmail("");
          setNewsletterName("");
          setTermAccepted(false);
        } else {
          props.application.setLoading(false);
          toast.error(response?.message || "An error occurred");
          return;
        }
      } catch (err) {
        props.application.setLoading(false);
       const message= handleConsoleError(err);
        const errorMessage = err?.message || message;
        toast.error(errorMessage);
      }
    }
  };
  const showSignUp = () => {
    if (!loginUser) {
      return (
        <div className="slider-text">
          <div className="slider-text2">
            <h4>
              We Make <span>Event Planning & Participating</span> Easy,
              Automated and Cheaper!{" "}
            </h4>
            <p>Select your path</p>
            <div className="dropdown">
              <input
                type="checkbox"
                className="dropdown__switch"
                id="filter-switch"
                hidden
              />
              <Dropdown className="custom-dropdown-container">
                <Dropdown.Toggle
                  className="dropdown-toggle"
                  style={{ width: "100%", textAlign: "left" }}
                  variant="success"
                >
                  {props?.application?.activeRole
                    ? props?.application?.activeRole?.roleName
                    : "I’m a.."}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-item-container">
                  {props?.application?.roles?.map((role, index) => (
                    <Dropdown.Item
                      value={role}
                      key={index}
                      onClick={() => {
                        handleRoleChange(role);
                      }}
                      role={role}
                      className="custom-dropdown-item"
                    >
                      {role?.roleName}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              {props?.application?.activeRole ? (
                <Button
                  onClick={handleSignup}
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    marginTop: 20,
                  }}
                >
                  Sign up
                </Button>
              ) : (
                <></>
              )}

              <label
                htmlFor="filter-switch"
                className="dropdown__options-filter"
              ></label>
            </div>
          </div>
        </div>
      );
    } else return <></>;
  };

  return (
    <React.Fragment>
      <section className="landing-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="5"
              aria-label="Slide 6"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="6"
              aria-label="Slide 7"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src="assets/images/slider-1.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-2.jpg"
                className="d-block w-100"
                alt="..."
              />

              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-3.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-4.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-5.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-6.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
            <div className="carousel-item">
              <img
                src="assets/images/slider-7.jpg"
                className="d-block w-100"
                alt="..."
              />
              {showSignUp()}
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>
      <section className="event-tabs">
        <div className="container">
          <h3>
            Latest <span> Events</span>
          </h3>
          <div className="event-tabs-img">
            <img src="/assets/images/date-icon.png" alt="" />
          </div>

          <div id="page">
            <div className="row">
              <div className="column small-11 small-centered art1">
                <CategorySlider
                  activeCategory={activeCategory}
                  onCategoryChange={async (category) => {
                    setActiveCategory(category?.id);
                    await getEventsByCategoryId(category?.id);
                  }}
                ></CategorySlider>
              </div>
            </div>
          </div>

          <div className="content">
            <LatestEvents
              isShowAll
              handleAllEvents={() => {}}
              categoryId={activeCategory}
            ></LatestEvents>
          </div>
        </div>
      </section>
      <section className="upcoming-events">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div
                onClick={() => {
                  navigate(routes.GLOBAL_EVENTS.replace(":type", "upcoming"), {
                    state: { type: "upcoming" },
                  });
                }}
                className="upcoming-events1"
                style={{ cursor: "pointer" }}
              >
                <div className="upcoming-events2">
                  <h4>
                    UPCOMING <br /> EVENTS{" "}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div
                onClick={() => {
                  navigate(routes.GLOBAL_EVENTS.replace(":type", "present"), {
                    state: { type: "present" },
                  });
                }}
                className="upcoming-events1"
                style={{ cursor: "pointer" }}
              >
                <div className="upcoming-events2">
                  <h4>
                    PRESENT <br /> EVENTS{" "}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div
                onClick={() => {
                  navigate(routes.GLOBAL_EVENTS.replace(":type", "past"), {
                    state: { type: "past" },
                  });
                }}
                className="upcoming-events1"
                style={{ cursor: "pointer" }}
              >
                <div className="upcoming-events2">
                  <h4>
                    PAST <br /> EVENTS{" "}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news-latter-form">
        <div className="container">
          <div className="news-latter-text">
            <h3>Newsletter</h3>
            <div className="event-tabs-img news">
              <img src="/assets/images/mail-icon.png" alt="" />
            </div>
            <p>
              Stay updated on top events, exclusive promotions, and expert tips
              for unforgettable experiences.
            </p>
          </div>
          <div className="gt-columns gt-column-3 gt-column-space-30">
            <div className="col-sm-12 col-md-6 col-lg-4 gt-col">
              <div className="gt-inner">
                <input
                  type="email"
                  name="EMAIL"
                  placeholder="Enter email address"
                  required=""
                  value={newsletterEmail}
                  autoFocus=""
                  onChange={handleEmailChange}
                />
                {/* {emailError && <p className="text-danger">{emailError}</p>} */}
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4 gt-col">
              <div className="gt-inner">
                <input
                  type="text"
                  name="FNAME"
                  placeholder="Enter your name"
                  required=""
                  value={newsletterName}
                  autoFocus=""
                  onChange={handleNameChange}
                />
                {/* {nameError && <p className="text-danger">{nameError}</p>} */}
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4 gt-col">
              <div className="gt-inner-check">
                <input
                  checked={isTermsAccepted}
                  onChange={(e) => {
                    setTermAccepted(e.target.checked);
                  }}
                  name="AGREE_TO_TERMS"
                  id="mailchamp-agree-terms"
                  type="checkbox"
                  className="gt-checkbox"
                  value="1"
                  required=""
                />
                <h6>
                  I have agreed to{" "}
                  <a
                    href="#!"
                    onClick={() => {
                      setTermsShow(true);
                    }}
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Terms & Conditions
                  </a>
                  .
                </h6>
              </div>
            </div>
            <div className="gt-columns gt-column-3 gt-column-space-30">
              <div className="col-sm-12 col-md-6 col-lg-4 gt-col">
                <div className="gt-inner">
                  <button onClick={handleSubmit} type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* {termError && <p className="text-danger">{termError}</p>} */}
        </div>
      </section>
      <section className="why-choose">
        <div className="container">
          <div className="news-latter-choose">
            <h3>
              Why Choose <span>Swallow Events</span>
            </h3>
            <div className="event-tabs-img">
              <img src="/assets/images/why-choose.png" alt="" />
            </div>
            <p>
              We simplify planning, boost engagement, and create unforgettable
              experiences.
            </p>
          </div>
        </div>
      </section>
      <ModelPopup
        title="Terms & Conditions"
        isHtml
        description={globalConstant.termsHtmlText}
        show={termsShow}
        onClose={() => {
          setTermsShow(false);
        }}
      ></ModelPopup>
    </React.Fragment>
  );
}

export default injectModels(["application"])(HomePage);
